<template>
  <AuthContainer>
    <TextInput v-for="i in inputs" :title="i.title" :placeholder="i.placeholder" :type="i.type" :name="i.name" :key="i.name"  v-on:datachanged="dataChanged"/>
    <Button title="Giriş" :onclick="login"/>
  </AuthContainer>
</template>

<script>
import TextInput from '@/components/forms/TextInput'
import AuthContainer from '@/views/containers/AuthContainer'
import Button from '@/components/forms/Button'
import firebase from 'firebase'
export default {
  name: 'Login',
  components: { Button, AuthContainer, TextInput },
  data () {
    return {
      mail: '',
      sifre: '',
      inputs: [
        { title: 'Email', placeholder: 'Email adresinizi girin', name: 'mail', type: 'text' },
        { title: 'Şifre', placeholder: 'Şifre', name: 'sifre', type: 'password' }
      ]
    }
  },
  methods: {
    login (e) {
      firebase
        .auth()
        .signInWithEmailAndPassword(this.mail, this.sifre)
        .then(data => {
          // this.$router.replace({ name: 'Dashboard' })
          window.location = '/'
        })
        .catch(err => {
          // this.error = err.message
          alert(err)
        })
    },
    dataChanged (data, name) {
      this[name] = data
    }
  }
}
</script>

<style scoped>

</style>
